export default "__VITE_ASSET__XnQTiyo7__"